import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { PromiseType } from 'utility-types';

import { getDraftsCountCreatedByForm } from '@app/store/transport-layer/form/drafts/count-created-by-form';

export default function useDraftCountCreatedByForm(workspaceId: string) {
  return useQuery<PromiseType<ReturnType<typeof getDraftsCountCreatedByForm>>, AxiosError>({
    queryKey: ['draftsCountCreatedByForm', workspaceId],
    queryFn: () => getDraftsCountCreatedByForm(workspaceId),
    enabled: !!workspaceId,
  });
}
